/* HexaGlow theme scripts */
(function () {
  "use strict";

  /* sticky header */
  var raf = function (fn) {
    var ticking = false;
    return function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; fn(); });
    };
  };

  var header = document.querySelector(".site-header");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("scrolled", window.scrollY > 24);
    };
    onScroll();
    window.addEventListener("scroll", raf(onScroll), { passive: true });
  }

  /* fade-up on scroll */
  var faded = document.querySelectorAll(".fade-up");
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.05 }
    );
    faded.forEach(function (el) { io.observe(el); });
  } else {
    faded.forEach(function (el) { el.classList.add("is-visible"); });
  }

  /* product configurator */
  var root = document.querySelector("[data-product-form]");
  if (!root) return;

  var productJson = document.getElementById("product-json");
  if (!productJson) return;
  var data;
  try {
    data = JSON.parse(productJson.textContent);
  } catch (error) {
    console.error("HexaGlow product data could not be read.", error);
    return;
  }
  var moneyFormat = root.getAttribute("data-money-format") || "${{amount}}";

  var state = {
    color: root.getAttribute("data-default-color"),
    size: root.getAttribute("data-default-size"),
    quantity: 1
  };

  var mainImg = root.querySelector("[data-main-image]") || root.querySelector(".gallery-main img");
  var priceEl = root.querySelector("[data-price]");
  var qtyOut = root.querySelector("[data-qty]");
  var addBtn = root.querySelector("[data-add]");
  var idInput = root.querySelector("[data-variant-id]");
  var qtyInput = root.querySelector("[data-quantity-input]");
  var stickyPrice = document.querySelector("[data-sticky-price]");

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace(".", ","));
  }

  function norm(x) {
    return String(x == null ? "" : x).toLowerCase().replace(/[\u2013\u2014-]/g, " ").replace(/\s+/g, " ").trim();
  }

  function currentVariant() {
    var i, v;
    for (i = 0; i < data.variants.length; i++) {
      v = data.variants[i];
      if (norm(v.color) === norm(state.color) && norm(v.size) === norm(state.size)) return v;
    }
    /* fall back to any variant with the selected size so the price still updates */
    for (i = 0; i < data.variants.length; i++) {
      v = data.variants[i];
      if (norm(v.size) === norm(state.size)) return v;
    }
    for (i = 0; i < data.variants.length; i++) {
      v = data.variants[i];
      if (norm(v.color) === norm(state.color)) return v;
    }
    return data.variants[0] || null;
  }

  function render() {
    root.querySelectorAll("[data-color]").forEach(function (b) {
      b.setAttribute("aria-pressed", String(b.getAttribute("data-color") === state.color));
    });
    root.querySelectorAll("[data-size]").forEach(function (b) {
      b.setAttribute("aria-pressed", String(b.getAttribute("data-size") === state.size));
    });

    var v = currentVariant();
    if (v && priceEl) priceEl.textContent = formatMoney(v.price * state.quantity);
    if (stickyPrice && v) stickyPrice.textContent = formatMoney(v.price * state.quantity);
    if (idInput && v) idInput.value = v.id;
    if (qtyInput) qtyInput.value = state.quantity;
    if (qtyOut) qtyOut.textContent = state.quantity;
    if (addBtn) {
      addBtn.disabled = !v || !v.available;
      addBtn.setAttribute("aria-disabled", String(!v || !v.available));
    }
  }

  root.querySelectorAll("[data-color]").forEach(function (b) {
    b.addEventListener("click", function () {
      state.color = b.getAttribute("data-color");
      var img = b.getAttribute("data-color-image");
      if (img && mainImg) { mainImg.src = img; mainImg.alt = b.getAttribute("data-color-alt") || mainImg.alt; }
      render();
    });
  });

  root.querySelectorAll("[data-size]").forEach(function (b) {
    b.addEventListener("click", function () {
      state.size = b.getAttribute("data-size");
      render();
    });
  });

  var dec = root.querySelector("[data-qty-dec]");
  var inc = root.querySelector("[data-qty-inc]");
  if (dec) dec.addEventListener("click", function () { state.quantity = Math.max(1, state.quantity - 1); render(); });
  if (inc) inc.addEventListener("click", function () { state.quantity = Math.min(20, state.quantity + 1); render(); });

  /* gallery thumbs */
  document.querySelectorAll("[data-thumb]").forEach(function (t) {
    t.addEventListener("click", function () {
      document.querySelectorAll("[data-thumb]").forEach(function (o) { o.setAttribute("aria-current", "false"); });
      t.setAttribute("aria-current", "true");
      if (mainImg) {
        mainImg.src = t.getAttribute("data-thumb");
        mainImg.alt = t.getAttribute("data-thumb-alt") || mainImg.alt;
      }
    });
  });

  /* add to cart (AJAX) */
  var form = root.querySelector("form[action*='/cart/add']");
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var v = currentVariant();
      if (!v) return;
      addBtn.disabled = true;
      var label = addBtn.textContent;
      addBtn.textContent = "Adding…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: v.id, quantity: state.quantity }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.href = "/cart"; })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = label;
          alert("Sorry, we could not add that to your bag. Please try again.");
        });
    });
  }

  /* buy now -> straight to Shopify checkout */
  var buyNow = root.querySelector("[data-buy-now]");
  if (buyNow) {
    buyNow.addEventListener("click", function () {
      var v = currentVariant();
      if (!v) return;
      buyNow.disabled = true;
      buyNow.textContent = "Redirecting…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: v.id, quantity: state.quantity }] })
      })
        .then(function () { window.location.href = "/checkout"; })
        .catch(function () {
          buyNow.disabled = false;
          buyNow.textContent = "Buy now";
        });
    });
  }

  /* mobile sticky buy bar */
  var sticky = document.querySelector(".sticky-buy");
  var anchor = document.querySelector("[data-sticky-anchor]");
  if (sticky && anchor) {
    var toggle = function () {
      sticky.classList.toggle("show", anchor.getBoundingClientRect().bottom < 0);
    };
    toggle();
    window.addEventListener("scroll", raf(toggle), { passive: true });
    window.addEventListener("resize", raf(toggle), { passive: true });
    var stickyBtn = sticky.querySelector("[data-sticky-add]");
    if (stickyBtn) stickyBtn.addEventListener("click", function () {
      if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event("submit", { cancelable: true }));
    });
  }

  render();
})();
